import React from 'react';
import './index.less';
import classNames from 'classnames';
import ABSIconText from '../ABSIconText';

export interface IABSAddCardProps {
  onClick?: () => void;
  className?: string;
  icon: string;
  text: string;
  size?: 'small' | 'default';
  block?: boolean;
}

class ABSAddCard extends React.Component<IABSAddCardProps> {
  static defaultProps = {
    size: 'default',
    block: false
  };
  render() {
    const { onClick, className, icon, text, size, block } = this.props;
    const classs = classNames('abs-add-card', 'abs-add-card-' + size, { 'abs-add-card-block': block}, className);
    const iconSize = size === 'default' ? 'xl' : 'm';
    return ( 
      <div className={classs} onClick={onClick}>
        <ABSIconText fontSize={iconSize} icon={icon} text={text} />
      </div>
    );
  }
}

export default ABSAddCard;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAddCard/index.tsx